// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PersonalDetailsActionType from './personal-details.types';
import {
	personalDetailsSuccess,
	personalDetailsFailure,
	personalDetailsUserResponseChanged,
} from './personal-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { personalDetailsMember } from './personal-details.service';

/** ***************** Personal Details Add Start ************************/
export function* PersonalDetails({ payload }: any) {
	try {
		const key = 'PersonalFamilyDetails';
		const {
			companyID,
			databaseName,
			memberID,
			memberDOB,
			memberAge,
			maritialStatus,
			fatherName,
			motherName,
			spouseName,
			spouseDOB,
			alternatePhoneNumber,
			selectedIdProof,
			idProofNumber,
			addressProofType,
			addressProofNumber,
			addressProofName,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberDOB: memberDOB,
			MemberAge: memberAge,
			MaritalStatus: maritialStatus,
			FatherName: fatherName,
			MotherName: motherName,
			SpouseName: spouseName,
			SpouseDOB: spouseDOB,
			AlternatePhoneNumber: alternatePhoneNumber,
			IDProofType: selectedIdProof,
			IDProofNumber: idProofNumber,
			AddressProofType: addressProofType,
			AddressProofNumber: addressProofNumber,
			AddressProofName: addressProofName,
			OfficerID: userID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(personalDetailsMember, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(personalDetailsFailure(responseData.data));
		} else {
			yield put(personalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(personalDetailsFailure(error));
	}
}

export function* PersonalDetailsResponseClear() {
	yield put(personalDetailsUserResponseChanged());
}

export function* onPersonalDetailsStart() {
	yield takeLatest(PersonalDetailsActionType.PERSONAL_DETAILS_START, PersonalDetails);
}

export function* onPersonalDetailsResponseReset() {
	yield takeLatest(
		PersonalDetailsActionType.PERSONAL_DETAILS_RESPONSE_REST_START,
		PersonalDetailsResponseClear,
	);
}
/** ***************** Personal Details Add End ************************/

export function* personalDetailsSaga() {
	yield all([call(onPersonalDetailsStart), call(onPersonalDetailsResponseReset)]);
}
